export default __webpack_public_path__ + "static/media/pan@2x.e155ea77.png";